const ABObjectCore = require("../core/ABObjectCore");
module.exports = class ABObjectExternal extends ABObjectCore {};
